var map = {
	"./97212_Ventures.png": 2035,
	"./ATEM_Capital.png": 961,
	"./Adit_Ventures.png": 4510,
	"./Adventure_Fund.png": 6793,
	"./Agent_Capital.png": 4158,
	"./Allstate_Strategic_Ventures.png": 7719,
	"./Altari_Ventures.png": 2209,
	"./Alumni_Ventures.png": 4183,
	"./Amzak_Health.png": 742,
	"./Anthemis.png": 1761,
	"./Anthropocene_Ventures.png": 318,
	"./Augment_Ventures.png": 4150,
	"./Aurum_Venture_Partners.png": 195,
	"./Azafran_Capital_Partners.png": 3298,
	"./BDMI.png": 4442,
	"./Bachmanity_Capital.png": 8253,
	"./Backswing_Ventures.png": 1913,
	"./Baker_Hall_Capital.png": 9406,
	"./BankTech_Ventures.png": 6727,
	"./Black_Opal_Ventures.png": 8915,
	"./Blackhorn_Ventures.png": 9354,
	"./Brown_Venture_Group.png": 2892,
	"./Builders_+_Backers.png": 2297,
	"./CSC_Upshot_Ventures.png": 8721,
	"./CTI_Life_Sciences_Fund.png": 9151,
	"./Centre_Street_Partners.png": 1768,
	"./Cleveland_Avenue.png": 2295,
	"./Climate_Capital.png": 9841,
	"./CoinFund.png": 4317,
	"./Contango_Digital_Assets.png": 9018,
	"./Crosslink_Capital.png": 798,
	"./Cycle_Capital.png": 5761,
	"./Darkmode_Ventures.png": 4084,
	"./Deutsche_Bank_Corporate_Venture_Capital.png": 7060,
	"./Distributed_Ventures.png": 1992,
	"./Dreamit_Ventures.png": 8722,
	"./Energy_Foundry.png": 5246,
	"./Fiat_Ventures.png": 9571,
	"./Flair_Ventures.png": 3899,
	"./Flashpoint_VC.png": 7958,
	"./Forward_Leap_Capital.png": 6035,
	"./Framework_Venture_Partners.png": 396,
	"./Gefen_Capital.png": 8097,
	"./General_Inception.png": 2377,
	"./Good_AI_Capital.png": 4091,
	"./Halcyon_Fund.png": 4331,
	"./Hat-Trick_Capital.png": 8733,
	"./Iter_Investments.png": 2226,
	"./J&T_Ventures.png": 7936,
	"./January_Ventures.png": 6361,
	"./JetBlue_Ventures.png": 3974,
	"./Joyance_Partners.png": 2371,
	"./Kapor_Capital.png": 9765,
	"./Knickerbocker_Financial_Group.png": 8552,
	"./LongeVC.png": 6469,
	"./MGM_Innova_Capital.png": 5088,
	"./MVM_Partners.png": 7377,
	"./Material_V.png": 1595,
	"./MidAtlantic_Fund.png": 9403,
	"./Motus_Ventures.png": 6842,
	"./Mount_Sinai_Innovation_Partners.png": 4206,
	"./New_Era_Capital_Partners.png": 7321,
	"./Next_Sparc_Growth_Partners.png": 6177,
	"./Orbit_Startups.png": 657,
	"./Osage_Venture_Partners.png": 9950,
	"./Outsiders_Fund.png": 4820,
	"./Pentas_Ventures.png": 2283,
	"./Pharus_Ventures.png": 6464,
	"./Precursor_Ventures.png": 3318,
	"./Presidio_Ventures.png": 9893,
	"./Prithvi_Ventures.png": 5887,
	"./Progression_Fund.png": 4566,
	"./RTP_Global.png": 6426,
	"./Root_and_Shoot_Ventures.png": 4622,
	"./SV_Health_Investors.png": 5299,
	"./Seaplane_Ventures.png": 8972,
	"./Sixty_Degree_Capital.png": 3812,
	"./Skyview_Ventures.png": 7371,
	"./SoGal_Ventures.png": 5424,
	"./SoundBoard_Venture_Fund.png": 7572,
	"./Squadra_Ventures.png": 9162,
	"./The_Fintech_Fund.png": 6538,
	"./TransAtlantic_Venture_Partners.png": 692,
	"./Tribeca_Venture_Partners.png": 3066,
	"./True_Wealth_Ventures.png": 1607,
	"./Unconventional_Ventures.png": 1272,
	"./Urban_Innovation_Fund.png": 5086,
	"./Valhalla_Ventures.png": 5445,
	"./Verstra_Ventures.png": 3450,
	"./Vestech_Partners.png": 5912,
	"./Vibranium.VC.png": 4832,
	"./Viewpoint_Ventures.png": 4770,
	"./WAVE_Equity_Partners.png": 9342,
	"./Wavemaker_Three-Sixty_Health.png": 4585,
	"./Xcellerant_Ventures.png": 7367,
	"./ego_death_capital.png": 4390
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4284;